export default {"src":"/_next/static/media/icon_chat_add_friend.c0bba1fa.svg","height":20,"width":23,"blurWidth":0,"blurHeight":0};